import { User } from "@/models/User";

export class Company {
  entityMessage() {
    return `La société ${this.nomComplet}`;
  }

  constructor({
    id = null,
    nom = null,
    nomComplet = null,
    code = null,
    societeId = null,
    societe = null,
    referentId = null,
    referent = {},
    logo = null,
    abonnements = [],
    temporaire = true
  } = {}) {
    this.id = id;
    this.nom = nom;
    this.nomComplet = nomComplet !== null ? nomComplet : nom;
    this.code = code;
    this.societeId = societeId;
    this.societe = societe ? societe : {};
    this.referentId = referentId;
    this.referent = referent && referent.id ? new User(referent) : {};
    this.logo = logo;
    this.abonnements = abonnements ? abonnements : [];
    this.abonnements.forEach(abonnement => {
      abonnement.used = true;
      abonnement.acces.forEach(acces => {
        acces.used = true;
      });
    });
    this.temporaire = temporaire;
  }
}
